import { useState, useEffect } from 'react';
import Navbar from '../components/layout/Navbar';
import SearchBar from '../components/common/SearchBar';
import ShopList from '../components/shops/ShopList';
import BlurOverlay from '../components/ui/BlurOverlay';
import Footer from '../components/layout/Footer';
import SimpleMap, { MapLocation } from '../components/map/SimpleMap';
import { useToast } from '@/hooks/use-toast';
import { dummyShops } from '@/components/shops/ShopList';
const INITIAL_LAT = 32.194997;
const INITIAL_LNG = 35.291136;
const Shops = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [showMap, setShowMap] = useState(false);
  // Center map on Nablus area (from given link)
  const [mapCoords, setMapCoords] = useState({
    lat: INITIAL_LAT,
    lng: INITIAL_LNG
  });
  const [shopLocations, setShopLocations] = useState<MapLocation[]>([]);
  const {
    toast
  } = useToast();

  // Transform shop data into map locations
  useEffect(() => {
    // Create map locations from shop data
    // In a real app, these coordinates would come from your API or database
    // For this demo, we'll generate some coordinates around the default location
    const locations: MapLocation[] = dummyShops.map((shop, index) => {
      // Parse the distance string to get a number (e.g., "1.2 km" -> 1.2)
      const distanceValue = parseFloat(shop.distance);

      // Generate coordinates based on the base location and distance
      // This is a simplified approach - in reality you'd have actual coordinates
      const angle = index * 45 % 360; // Distribute shops in a circle
      const lat = mapCoords.lat + Math.cos(angle * Math.PI / 180) * distanceValue * 0.01;
      const lng = mapCoords.lng + Math.sin(angle * Math.PI / 180) * distanceValue * 0.01;
      return {
        id: shop.id,
        name: shop.name,
        lat,
        lng
      };
    });
    setShopLocations(locations);
  }, [mapCoords]);
  const handleSearch = (query: string) => {
    setSearchQuery(query);
    toast({
      title: "Search initiated",
      description: `Searching for shops with "${query}"`
    });
    console.log('Searching for shops with query:', query);
    // In a real app, this would trigger an API call
  };
  const handleNearMe = () => {
    navigator.geolocation.getCurrentPosition(position => {
      const {
        latitude,
        longitude
      } = position.coords;
      setMapCoords({
        lat: latitude,
        lng: longitude
      });
      setShowMap(true);
      toast({
        title: "Location found",
        description: "Showing shops near your current location"
      });
    }, error => {
      toast({
        variant: "destructive",
        title: "Location error",
        description: error.message || "Unable to get your location"
      });
      console.error("Geolocation error:", error);
    });
  };
  return <div className="min-h-screen bg-gradient-to-b from-white to-autocare-gray-light">
      <Navbar />

      <div className="pt-24 pb-16 page-container">
        {/* Header Section with Image */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex-1">
            <h1 className="text-3xl md:text-4xl font-bold text-autocare-blue mb-6">
              Find Oil Change Shops
            </h1>
            <p className="text-gray-600 max-w-2xl">
              Discover the best auto maintenance shops in Palestine. Filter by location, 
              services, and ratings to find the perfect place for your vehicle's needs.
            </p>
          </div>
          <div className="hidden md:block ml-8">
            <div className="relative w-80 h-48">
              <img alt="Auto service" className="w-full h-full object-cover rounded-2xl shadow-2xl" src="/lovable-uploads/081254eb-922d-46a1-b2ef-3131e03e8b31.png" />
              <div className="absolute -inset-0.5 bg-gradient-to-r from-autocare-yellow/50 to-autocare-blue-light/50 rounded-2xl blur-lg opacity-70 -z-10"></div>
            </div>
          </div>
        </div>

        <BlurOverlay className="mb-8">
          <div className="max-w-2xl mx-auto">
            <SearchBar placeholder="Search for shops by name or location..." onSearch={handleSearch} onNearMe={handleNearMe} className="mb-4" />
          </div>
        </BlurOverlay>

        {/* Always show map but set a state to control when to display user's location */}
        

        <ShopList className="mt-10" searchQuery={searchQuery} />
      </div>

      <Footer />
    </div>;
};
export default Shops;